import React from 'react'
import {Redirect, Route, Switch} from 'react-router-dom';
import RouterPath from 'libs/RouterPath';
import PurchasingGroupStages from "./stages/PurchasingGroupStages";
import PurchasingGroupList from "./list/PurchasingGroupList";
import PurchasingGroupMemberList from "./list/PurchasingGroupMemberList";
import NotFound from "../../NotFound/NotFound";
import PurchasingGroupTemplatesList from "./templates/PurchasingGroupTemplatesList";
import PurchasingGroupTemplate from "./templates/PurchasingGroupTemplate";

const rp = RouterPath.purchasingGroup;

function PurchasingGroup() {

    return (<>
            <Switch>
                <Route exact path={rp.MP_PURCHASING_GROUP}>
                    <Redirect to={rp.MP_PURCHASING_GROUP_LIST} push={false}/>
                </Route>
                <Route path={rp.MP_PURCHASING_GROUP_LIST} component={PurchasingGroupList}/>
                <Route path={rp.MP_PURCHASING_GROUP_MEMBER_LIST} component={PurchasingGroupMemberList}/>

                <Route exact path={rp.MP_PURCHASING_GROUP_TEMPLATES}>
                    <Redirect to={rp.MP_PURCHASING_GROUP_TEMPLATES_LIST} push={false}/>
                </Route>
                <Route path={rp.MP_PURCHASING_GROUP_TEMPLATES_LIST} component={PurchasingGroupTemplatesList}/>
                <Route path={rp.MP_PURCHASING_GROUP_TEMPLATES_TEMPLATE_ID} component={PurchasingGroupTemplate}/>

                <Route path={rp.MP_PURCHASING_GROUP_GROUP_ID_STAGE_NR} component={PurchasingGroupStages}/>
                <Route path={rp.MP_PURCHASING_GROUP_GROUP_ID} component={PurchasingGroupStages}/>
                <Route path={rp.MP_PURCHASING_GROUP_GROUP} component={PurchasingGroupStages}/>

                <Route component={NotFound}/>
            </Switch>
        </>
    )
}

export default PurchasingGroup;

